export default {
  loyalty:
    'I accept the terms of the <a target="_blank" href="{link}">loyalty program</a> of RC Group partners',
  posOferta:
    'I accept the terms of the <a target="_blank" href="https://cdn.rc.today/storage/partners/common/docs/ru/pos/Договор%20о%20присоединении%20к%20RC%20POS.pdf">agreement</a> for RC POS service',
  1: "Basic Information",
  2: "Personal Information",
  3: "Legal Entity",
  haveAcc: "Have an account?",
  login: "Log In",

  mainInfo: {
    title: "Basic Information",
    promocode: "Promo Code",
    country: "Country",
    phone: "Phone Number",
    checkbox:
      "I give my consent to the processing of personal data in accordance with the <a download href='{link}'>Privacy Policy</a>",
    oferta:
      "I accept the terms of the <a download href='{link}'>Offer Agreement</a>",
  },

  profileInfo: {
    title: "Personal Information",
    firstName: "First Name",
    lastName: "Last Name",
    middleName: "Middle Name",
    email: "Email",
    password: "Password",
    confPassword: "Confirm Password",
    registerCode: "Email Code",
    notSendCode: "Didn't receive the code?",
    sendAgain: "Send Again",
  },

  emailCode: {
    title: "Verification code sent to your email",
    subtitle:
      'If you didn\'t receive an email at "{mail}", check your Spam folder',
    emailCode: "Email Code",
    sendAgainTime: "Send code again in ",
    dontSend: "Didn't receive the code?",
    sendAgain: "Send Again",
  },

  entity: {
    title: "Legal Entity",
    subTitle: "Please check the entered data before clicking 'Next'",
    entityType: "Legal Entity Type",
    halalCertificate: "Legal entity has Halal certificate",
    fileType: "PNG, JPG, PDF - 1 file up to 10 MB",
    commercial: "Commercial",
    checkbox: "Legal entity engages in business activities",
  },

  payment: {
    title: "Thank you for registering!",
    subtitle: "You can now access your RC Group loyalty program account.",
    moderation:
      "Your legal entity is currently under moderation. Typically, verification takes 24 to 48 hours",
    examination:
      "To pass verification, you need to pay an invoice from the specified legal entity by downloading it using the button below. You can also find the invoice in your account: in the 'My Businesses' - 'Documents' section under the name 'Test Payment'.",

    goToCabinet: "Go to Account",
    alternativeCheck: {
      button: "Alternative verification method.",
      description:
        "You will need to download the 'Application Form' document, sign it, stamp it, and send it to the company's email.",
    },
  },

  alternativePayment: {
    title: "If you cannot pay the invoice",
    signDocAndSendToMail:
      "To pass verification, you need to sign the document by downloading it using the button below, and upload it to this page or send it to email <b>hello@rc.city</b>",
    whereIsDoc:
      "You can also find the document in your account: in the 'My Businesses' - 'Documents' section under the name 'Legal Entity Confirmation Form'",
    downloadFileName: "Application Form",
    useMainCheckWay: "Use main verification method",
    paymentInvoice: "Payment Invoice",
  },
};
